import { useState } from 'react';
import type { ChatRoomSummary } from '../../application/types';
import ChatThread from '../components/ChatThread';
import RoomList from '../components/RoomList';
import '../styles.scss';

export function ChatHomePage() {
  const [selectedRoom, setSelectedRoom] = useState<ChatRoomSummary | null>(
    null,
  );

  return (
    <div className="chat-page">
      <RoomList
        onSelectChat={setSelectedRoom}
        selectedRoomId={selectedRoom?.id ?? null}
      />
      <ChatThread selectedRoom={selectedRoom} />
    </div>
  );
}

export default ChatHomePage;
